import styled from "styled-components";

export const CardRoot = styled.div.attrs({ role: "button", tabIndex: 0 })`
  width: 360px;
  min-width: 360px;
  max-width: 360px;
  border: 0;
  padding: 0;
  background: transparent;
  text-align: left;
  cursor: pointer;
  color: ${({ theme }) => theme.palette.colors.text};
  transition: transform 0.28s cubic-bezier(0.22, 1, 0.36, 1);

  &:hover {
    transform: translateY(-4px);
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.palette.blue.main};
    outline-offset: 4px;
  }

  @media (max-width: 991px) {
    width: min(360px, 100%);
    min-width: min(360px, 100%);
    max-width: min(360px, 100%);
  }
`;

export const CardImage = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: 14px;
  overflow: hidden;
  background:
    linear-gradient(180deg, rgba(2, 6, 24, 0.08), rgba(2, 6, 24, 0.76)),
    ${({ image, theme }) => image ? `url(${image}) center / cover no-repeat` : theme.palette.colors.surfaceElevated};
  box-shadow: 0 18px 42px ${({ theme }) => theme.palette.colors.shadowStrong};

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(90deg, rgba(21, 93, 252, 0.16), rgba(21, 93, 252, 0));
    opacity: 0;
    transition: opacity 0.28s ease;
  }

  ${CardRoot}:hover &::after {
    opacity: 1;
  }
`;

export const CardTopline = styled.div`
  position: absolute;
  left: 12px;
  right: 12px;
  bottom: 12px;
  z-index: 2;
  display: flex;
  justify-content: space-between;
  gap: 8px;
`;

export const CardBadge = styled.div`
  min-height: 28px;
  border-radius: 8px;
  padding: 6px 11px;
  background: rgba(15, 23, 43, 0.86);
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  line-height: 16px;
  text-transform: uppercase;
`;

export const CardPlay = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 2;
  width: 58px;
  height: 58px;
  border: 3px solid rgba(255, 255, 255, 0.88);
  border-radius: 999px;
  transform: translate(-50%, -50%);
  background: rgba(2, 6, 24, 0.18);
  backdrop-filter: blur(4px);

  &::before {
    content: "";
    position: absolute;
    left: 22px;
    top: 16px;
    width: 0;
    height: 0;
    border-top: 11px solid transparent;
    border-bottom: 11px solid transparent;
    border-left: 16px solid rgba(255, 255, 255, 0.9);
  }
`;

export const CardBody = styled.div`
  padding: 16px 2px 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const CardMeta = styled.div`
  display: grid;
  grid-template-columns: 96px 1fr;
  gap: 10px;
  align-items: center;
`;

export const CardStats = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const StatText = styled.div`
  min-height: 28px;
  border-radius: 999px;
  padding: 5px 10px;
  background: ${({ theme }) => theme.palette.colors.badgeMuted};
  color: ${({ theme }) => theme.palette.colors.muted};
  font-size: 13px;
  font-weight: 700;
  line-height: 18px;
`;

export const ProgressLabel = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: ${({ theme }) => theme.palette.colors.subdued};
`;

export const ProgressBar = styled.div`
  height: 6px;
  border-radius: 999px;
  overflow: hidden;
  background: ${({ theme }) => theme.palette.colors.borderSoft};
`;

export const ProgressFill = styled.div`
  height: 100%;
  border-radius: inherit;
  background: ${({ theme }) => theme.palette.blue.main};
`;

export const CardTitle = styled.div`
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.3;
`;

export const CardDescription = styled.div`
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  font-size: 16px;
  line-height: 1.5;
  color: ${({ theme }) => theme.palette.colors.muted};
`;

export const CardCta = styled.div`
  width: fit-content;
  margin-top: 2px;
  color: ${({ theme }) => theme.palette.blue.main};
  font-size: 15px;
  font-weight: 800;
  line-height: 1.3;
`;
